import SecondaryPage from './projects/templates/SecondaryPageTemplate'

export default function NotFound() {
	return <SecondaryPage>Not Found</SecondaryPage>
}
